<template>
<div>
  <router-view></router-view>
</div>
</template>

<script>
export default {
  name: "Show"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Show.vue